import { render, staticRenderFns } from "./CustomBubbleMenus.vue?vue&type=template&id=06e9e7ae&"
import script from "./CustomBubbleMenus.vue?vue&type=script&lang=js&"
export * from "./CustomBubbleMenus.vue?vue&type=script&lang=js&"
import style0 from "./CustomBubbleMenus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports